/**
 * RequirePermission（03 3.2.3）：permissions に無ければ URL を変えずに ForbiddenPage（ERR-403）を出す（ダッシュボードへ黙って戻さない）。
 * allOf はすべて必要、anyOf はどれか 1 つ。
 */
import type { ReactNode } from 'react';
import { usePermission } from '../../features/auth/hooks/usePermission';
import { ForbiddenPage } from '../../pages/errors/ForbiddenPage';

export interface RequirePermissionProps {
  allOf?: readonly string[];
  anyOf?: readonly string[];
  children: ReactNode;
}

export function RequirePermission({ allOf, anyOf, children }: RequirePermissionProps) {
  const permission = usePermission();
  const is_allowed =
    (allOf === undefined || permission.canAll(allOf)) && (anyOf === undefined || permission.canAny(anyOf));
  return is_allowed ? <>{children}</> : <ForbiddenPage />;
}
